module.exports = __webpack_public_path__ + "static/img/D03-盈丰小学1.9fb62d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schoolImg/D03-盈丰小学1.png
// module id = rEDs
// module chunks = 0